import React, { type ReactNode } from 'react';
import { Alert, AlertTitle, Snackbar, useTheme } from '@mui/material';
import type { AlertColor } from '@mui/material/Alert';
import { alpha } from '@mui/material/styles';
import { borderRadius } from '../../../theme/theme';

export interface WizardSnackbarAlertProps {
  open: boolean;
  onClose: () => void;
  severity: AlertColor;
  title: ReactNode;
  children?: ReactNode;
  autoHideDuration?: number;
}

/**
 * Shared wizard notification snackbar so every setup page renders the
 * same top-centered alert chrome.
 */
const WizardSnackbarAlert: React.FC<WizardSnackbarAlertProps> = ({
  open,
  onClose,
  severity,
  title,
  children,
  autoHideDuration = 6000,
}) => {
  const theme = useTheme();

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          width: '100%',
          borderRadius: `${borderRadius.md}px`,
          boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.15)}`,
        }}
      >
        <AlertTitle>{title}</AlertTitle>
        {children}
      </Alert>
    </Snackbar>
  );
};

export default WizardSnackbarAlert;
